import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '@shared/app-component-base';
import { StorageDto, UserServiceProxy, WarehouseServiceProxy } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-select-storage',
  templateUrl: './select-storage.component.html',
  styleUrls: ['./select-storage.component.css']
})

export class SelectStorageComponent extends AppComponentBase implements OnInit {

  dataSource: StorageDto[] = [];
  isDisabled: boolean = false;
  companyId: number = 0;

  @Input()
  showAll: boolean = true;

  @Input()
  placeholder: string = this.l('Storage');

  // @Input()
  // manuelDisabled: boolean = null;

  // Warehouse
  private _warehouseId: number = 0;
  @Input()
  set warehouseId(value: number) {
    if (this._warehouseId === value) {
      return;
    }
    this._warehouseId = value;
    this.loadStorageList();
  }

  // selection
  private _selection: number = 0;
  get selection(): number {
    return this._selection;
  }
  @Input()
  set selection(value: number) {
    if (this._selection === value) {
      return;
    }
    this._selection = value;
    this.selectionChange.emit(this._selection);
  }
  // @Input() selection: number;
  @Output() selectionChange = new EventEmitter<number>();

  constructor(injector: Injector,
    private _warehouseService: WarehouseServiceProxy,
    /* private _userService: UserServiceProxy*/) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadStorageList();

    // this._userService.get(abp.session.userId).subscribe(result => {
    //   this.isDisabled = !result.isChangeWarehouse;
    //   if (this.manuelDisabled != null)
    //     this.isDisabled = this.manuelDisabled;
    //   if (!result.isChangeWarehouse) {
    //     this.selection = result.warehouseId;
    //   }
    // });
  }

  onSelectionChnaged() {
    this.selectionChange.emit(this.selection);
  }

  private loadStorageList(){
    this._selection = 0;
    if(this._warehouseId == 0){
      this.dataSource == new StorageDto[0];
    } else {
      this._warehouseService.getStorageListByWarehouse(this._warehouseId)
        .subscribe((result) => {
          this.dataSource = result;
        });
    }
  }
}